import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TCommentApi, TCommentCreatePayload } from './types/commentApi.types'

export const commentApi = {
  getComments: ({ id = -1, limit = 0, offset = 0 }, { signal }: TSignalConfig) =>
    fetcher.query<TCommentApi[]>(`publication/${id}/comments?limit=${limit}&offset=${offset}`, { signal }),
  getResponses: (id: number, { signal }: TSignalConfig) =>
    fetcher.query<Omit<TCommentApi, 'responses'>[]>(`comment/${id}/responses`, { signal }),
  createComment: (payload: TCommentCreatePayload) =>
    fetcher.mutate<TCommentApi, TCommentCreatePayload & { files: never[] }>(
      '/comment',
      { ...payload, files: [] },
      { method: 'POST' },
    ),
  deleteComment: (commentId: number) =>
    fetcher.mutate<void, Record<string, never>>(`/comment/${commentId}`, {}, { method: 'DELETE' }),
}
